import { IUserSubprofileModel } from "../models";

const cleanUp = (initialHomePage?: string): string | undefined =>
  initialHomePage?.replace("/", "");

const findCurrentProfile = (profiles?: IUserSubprofileModel[]) =>
  profiles?.find((profile) => profile.CurrentProfile);

const findMainProfile = (profiles?: IUserSubprofileModel[]) =>
  profiles?.find((profile) => profile.Owner);

const sortSubProfiles = (profiles: IUserSubprofileModel[]) => {
  profiles.sort((a, b) => (a.Owner === b.Owner ? 0 : a.Owner ? -1 : 1));
};

export const userProfileHelper = {
  cleanUp,
  findCurrentProfile,
  findMainProfile,
  sortSubProfiles,
};
